module.exports = __webpack_public_path__ + "img/link-wasap.a13bb46d.png";